import { FakturacniProfil } from '../fakturacniProfil';
import { NahradniSazbaPujcovna } from '../nahradniSazbaPujcovna';

export const DEPENDENT_TABLES = <const>[
	FakturacniProfil.name,
	NahradniSazbaPujcovna.name,
];

export type DependentTableNames = typeof DEPENDENT_TABLES[number];
